import React from "react";
import QuickAlertRow from "../quickAlertRow";
import useListQuickAlerts from "./useListQuickAlerts";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { Status } from "../../../../common/constants";

interface IListQuickAlertsProps {
  search: string;
  selectedSeverity: string;
  selectedGroup: string;
}

const ListQuickAlerts: React.FC<IListQuickAlertsProps> = ({
  search,
  selectedSeverity,
  selectedGroup,
}) => {
  const {
    quickAlertsData,
    setQuickAlertsData,
    reorderAlerts,
    activeAccordion,
    closeAccordion,
    lastItemRef,
    hasMore,
    status,
    setIsDragging,
    reloadQuickAlertList,
  } = useListQuickAlerts(search,
    selectedSeverity,
    selectedGroup,);

  if (!quickAlertsData || quickAlertsData.length === 0) {
    return <div className="text-center">No Quick Alerts found.</div>;
  }

  return (
    <DragDropContext onDragStart={() => setIsDragging(true)}
    onDragEnd={async (result) => {
      setIsDragging(false);
      if (!result.destination) return;
  
      const draggedItem = quickAlertsData[result.source.index];
      const targetItem = quickAlertsData[result.destination.index];
  
      const reordered = Array.from(quickAlertsData);
  
      const fromIndex = reordered.findIndex(i => i._id === draggedItem._id);
      const toIndex = reordered.findIndex(i => i._id === targetItem._id);
  
      if (fromIndex === -1 || toIndex === -1) return;
  
      const [moved] = reordered.splice(fromIndex, 1);
      reordered.splice(toIndex, 0, moved);

      setQuickAlertsData(reordered);
      await reorderAlerts(reordered);
    }}>
      <Droppable droppableId="alerts">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {quickAlertsData.map((item, index) => {
              const isLast = index === quickAlertsData.length - 1;

              return (
                <Draggable draggableId={item._id} index={index} key={item._id}>
                    {(provided) => (
                      <div
                        ref={(node) => {
                          provided.innerRef(node);
                          if (isLast) lastItemRef(node);
                        }}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                      <QuickAlertRow
                        item={item}
                        index={index}
                        isActive={activeAccordion === index}
                        onClose={closeAccordion}
                        onDeleteSuccess={reloadQuickAlertList} 
                      />
                    </div>
                  )}
                </Draggable>
              );
            })}

            {provided.placeholder}
            {hasMore && status === Status.PENDING && (
              <div className="text-center py-4">Loading more alerts...</div>
            )}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default ListQuickAlerts;